import { useContext } from 'react';
import { HelpStoreContext, type HelpStore } from './helpStore';

export function useHelp(): HelpStore {
  const store = useContext(HelpStoreContext);
  if (!store) throw new Error('useHelp must be used within HelpProvider');
  return store;
}

/** For components that also render outside the provider (page-level tests, unrouted pages). */
export function useOptionalHelp(): HelpStore | undefined {
  return useContext(HelpStoreContext);
}
